<div class="page-content">
  <div [innerHTML]="content | safeHtml" class="markdown"></div>
</div>
